import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1304Component } from './kymw1304.component';
import { CheckPCodeService } from './api-services/check-pcode.service';


/**
 * Ｐコード一発選定画面 モジュール設定クラス
 *
 * @export KYMW1304Module
 * @class KYMW1304Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1304Component,
  ],
  providers: [
    CheckPCodeService,
  ],
})
export class KYMW1304Module {
}
